import axios from "./axios";

export async function fetchEmployees(controller) {
  return axios({
    method: "get",
    url: "/users/website",
    params: controller,
  })
    .then((response) => response.data)
    .catch((error) => error?.response?.data || { error: "Request failed" });
}


